import * as React from 'react'

import AddCardForm from '../../../../components/home/AddCardForm/AddCardForm'

import * as CardApiService from '../../../../services/api/requests/Card'

class AddCardPageForm extends React.Component {
  state = {
    apiKey: '',
    isLoading: false,
    reRender: {
      addCardForm: 0,
    },
  }

  successUrl = `${process.env.REACT_APP_BASE_URL}/tpa-redirect/add-card/success`
  failUrl = `${process.env.REACT_APP_BASE_URL}/tpa-redirect/add-card/fail`

  componentWillMount() {
    this.retrieveInitialData()
  }

  loading = value => {
    this.setState({ isLoading: value })
  }

  handleOnLoad = async e => {
    this.loading(true)
    const { reRender } = this.state
    const { onSuccess, onFail } = this.props

    const successRegExp = new RegExp(this.successUrl)
    const failRegExp = new RegExp(this.failUrl)
    const successEndPoint = '/tpa-redirect/add-card/success'
    const failEndPoint = '/tpa-redirect/add-card/fail'
    const iFrame = e.currentTarget

    try {
      const redirectUrl = e.target.contentWindow.location.href
      if (!successRegExp.test(redirectUrl) && !failRegExp.test(redirectUrl)) {
        iFrame.style.height = `${iFrame.contentWindow.document.body.scrollHeight}px`
      }
    } catch (error) {}

    try {
      const redirectUrl = e.target.contentWindow.location.href

      // if (successRegExp.test(redirectUrl)) {
      if (redirectUrl.includes(successEndPoint)) {
        if (onSuccess) {
          onSuccess()
        }
        // } else if (failRegExp.test(redirectUrl)) {
      } else if (redirectUrl.includes(failEndPoint)) {
        const urlString = redirectUrl
        const url = new URL(urlString)
        const addCardError = url.searchParams
          .get('message')
          .replace(/[+]/g, ' ')
          .split('|')
          .pop()

        this.setState({
          addCardError,
          reRender: {
            ...reRender,
            addCardForm: reRender.addCardForm + 1,
          },
        })

        if (onFail) {
          onFail()
        }
      }
    } catch (error) {
      console.debug('cross-origin frame fail')
    }

    this.loading(false)
  }

  getApiKey = async cb => {
    const { accessToken } = this.props

    if (accessToken) {
      try {
        const response = await CardApiService.postToken(accessToken)
        if (response.data.token) {
          this.setState(
            {
              apiKey: response.data.token,
              programCode: response.data.programCode,
            },
            cb,
          )
        }
      } catch (e) {
        const message =
          e && e.response && e.response.data && e.response.data.message
            ? e.response.data.message
            : 'Unable to Process'
        this.setState({
          addCardError: message,
        })
      }
    }
  }

  retrieveInitialData = async () => {
    const { waitRenderServer, renderServer } = this.props

    waitRenderServer(true)
    this.getApiKey(() => {
      renderServer()
    })
  }

  render() {
    const {
      apiKey,
      programCode,
      addCardError,
      reRender,
      isLoading,
    } = this.state

    return (
      <>
        <AddCardForm
          apiKey={apiKey}
          programCode={programCode}
          key={reRender.addCardForm}
          addCardError={addCardError}
          onLoad={this.handleOnLoad}
          loading={isLoading}
        />
      </>
    )
  }
}

AddCardPageForm.defaultProps = {}

AddCardPageForm.propTypes = {}

export default AddCardPageForm
